import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';

function AppLayout({ darkMode, onToggleDark }) {
  return (
    <div className={`app-wrapper${darkMode ? ' dark-mode' : ''}`}>
      <Sidebar />
      <div className="main-panel">
        <TopNavbar darkMode={darkMode} onToggleDark={onToggleDark} />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AppLayout;
